module.exports = __webpack_public_path__ + "static/media/twitter.979d2a52.svg";